"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    palette: {
        type: "dark",
        primary: {
            main: "#eee"
        },
        secondary: {
            main: "#111"
        }
    }
};
